import { DrawerContentStyleConfig } from '../types';

export const styleConfig: DrawerContentStyleConfig = {
  baseStyle: {
    bg: 'white',
  },
};
